import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLanguage } from '../context/LanguageContext';
import EventTeamFormModal from './EventTeamFormModal';
import EventTeamRosterModal from './EventTeamRosterModal';
import './EventInviteModal.css';

// Заявка команды на событие: новая команда под событие или своя существующая
// (основная либо прежняя под событие), для существующей — выбор состава на
// событие. data — ответ GET /api/events/:id/teams; если не передан, грузится здесь
const EventTeamEntry = ({ event, data: initialData, preferExisting, onClose, onDone }) => {
  const { t } = useLanguage();
  const [data, setData] = useState(initialData || null);
  const [error, setError] = useState('');
  const [rosterTeam, setRosterTeam] = useState(null);

  useEffect(() => {
    if (initialData) return undefined;

    let cancelled = false;
    axios.get(`/api/events/${event.id}/teams`)
      .then(response => { if (!cancelled) setData(response.data); })
      .catch(err => { if (!cancelled) setError(err.response?.data?.error || t('eventTeams.loadError')); });
    return () => { cancelled = true; };
  }, [event.id, initialData, t]);

  const message = error || (data && !data.can_create && data.available_teams.length === 0
    ? t('eventTeams.nothingToEnter')
    : null);

  if (message) {
    return (
      <div className="event-invite-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
        <div className="event-invite-modal">
          <div className="event-invite-header">
            <div>
              <h2>{t('eventTeams.formTitle')}</h2>
              <div className="event-invite-subtitle">{event.name}</div>
            </div>
            <button type="button" className="event-invite-close" onClick={onClose}>×</button>
          </div>
          <div className="event-invite-body">
            <div className="event-invite-message">{message}</div>
          </div>
        </div>
      </div>
    );
  }

  if (!data) return null;

  if (rosterTeam) {
    return (
      <EventTeamRosterModal
        event={event}
        team={rosterTeam}
        mode="attach"
        onClose={onClose}
        onSaved={onDone}
      />
    );
  }

  return (
    <EventTeamFormModal
      event={event}
      canCreate={data.can_create}
      availableTeams={data.available_teams}
      preferExisting={preferExisting}
      onClose={onClose}
      onSaved={onDone}
      onChooseTeam={setRosterTeam}
    />
  );
};

export default EventTeamEntry;
